export default {
  'servers.title': 'Azure Servers and Services Configuration',
  'servers.azureGraph': 'Azure Graph',
  'servers.azureGraphSharePoint': 'Azure Graph - SharePoint',
  'servers.emailServer': 'Email Server',
  'servers.powerBiServer': 'Power BI Server',
  'servers.addConfiguration': 'Add Configuration',

  'servers.azureGraphSharePointConfiguration': 'Azure Graph - SharePoint Configuration',
  'servers.azureGraphConfiguration': 'Azure Graph Configuration',
  'servers.emailServerConfiguration': 'Email Server Configuration',
  'servers.powerBIServerConfiguration': 'Power BI Server Configuration',
  'servers.form.clientId': 'Client ID',
  'servers.form.username': 'Username',
  'servers.form.password': 'Password',

  'servers.form.serverType': 'Server Type',
  'servers.form.fromEmail': 'From Email',
  'servers.form.fromName': 'From Name',
  'servers.form.port': 'Port',
  'servers.form.enableSsl': 'Enable SSL',
  'servers.form.useDefaultCredentials': 'Use Default Credentials',
  'servers.form.clientSecret': 'Client Secret',
  'servers.form.isAutoManaged': 'Is Auto Managed',
  'servers.form.authorityUrl': 'Authority URL',
  'servers.form.resourceUrl': 'Resource URL',
  'servers.form.apiUrl': 'API URL',
  'servers.form.embedUrlBase': 'Embed URL Base',
  'servers.form.redirectUrl': 'Redirect URL',
  'servers.form.sharePointCompanyUrl': 'Company URL',
};
